import Vue from 'vue'
import Router from 'vue-router'
// import Home from './views/Home.vue'
import LoginWindow from './views/LoginWindow'
import Register from './views/Register'
import EditView from './views/EditView'
import ResetPassword from './views/ResetPassword'
import ChangePassword from './views/ChangePassword'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('./views/About.vue')
    },
    {
      path: '/edit',
      name: 'edit',
      component: EditView,
      props: route => ({ ...route.params, ...route.query })
    },
    {
      path: '/register',
      name: 'register',
      component: Register,
      props: route => ({ ...route.params, ...route.query })
    },
    {
      path: '/login',
      component: LoginWindow,
      name: 'login',
      props: route => ({ ...route.params, ...route.query })
    },
    {
      path: '/resetpassword',
      component: ResetPassword,
      name: 'ResetPassword',
      props: route => ({ ...route.params, ...route.query })
    },
    {
      path: '/changepassword',
      component: ChangePassword,
      name: 'ChangePassword',
      props: route => ({ ...route.params, ...route.query })
    },
    {
      path: '/registerExistingUser',
      name: 'registerExistingUser',
      component: Register,
      props: true
    },
    {
      path: '/registertest',
      component: Register,
      props: {
        existingUser: true,
        loginData: { email: 'ss@asd.es', password: 'asdf1234' }
      }
    }
  ]
})

function hasQueryParams(route) {
  return !!Object.keys(route.query).length
}

router.beforeEach((to, from, next) => {
  if (!hasQueryParams(to) && hasQueryParams(from)) {
    next({ name: to.name, query: from.query, params: to.params })
  } else {
    next()
  }
})

export default router
